import { useEffect, useState } from "react";
import { Download, FileText, Play } from "lucide-react";
import { api } from "@/lib/api";
import { PageIntro, Reveal, Shell } from "@/components/layout/Shell";

export function VideosPage() {
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    api("/public/videos").then(d => setVideos(d.items || [])).catch(() => {});
  }, []);
  return (
    <Shell>
      <main className="inner-page">
        <PageIntro crumb="DCEA / Videos" title={<>Videos & <em className="gold-text">recordings</em></>} description="Highlights, workshops and stories from the DCEA community." />
        <div className="container video-grid">
          {videos.length ? videos.map((v, i) => (
            <Reveal key={v.id} delay={(i % 3) * 0.08}>
              <a href={v.url} target="_blank" rel="noreferrer" className="video-card" data-testid={`video-card-${i}`}>
                <div className="video-thumb"><img src={v.thumbnail} alt={v.title} /><span><i><Play size={24} fill="currentColor" /></i></span></div>
                <div><span className="card-kicker">{v.category || "Video"}</span><h3>{v.title}</h3><p>{v.description}</p></div>
              </a>
            </Reveal>
          )) : (
            <div className="empty-state" data-testid="videos-empty-state">No videos published yet.</div>
          )}
        </div>
      </main>
    </Shell>
  );
}

export function DownloadsPage() {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api("/public/documents").then(d => setDocs(d.items || [])).catch(() => {});
  }, []);
  return (
    <Shell>
      <main className="inner-page">
        <PageIntro crumb="DCEA / Downloads" title={<>Download <em className="gold-text">centre</em></>} description="Forms, circulars and reports for members and the community." />
        <div className="container document-list">
          {docs.length ? docs.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.06}>
              <div className="document-row" data-testid={`document-row-${i}`}>
                <div className="document-icon"><FileText size={22} /></div>
                <div className="document-body">
                  <span className="card-kicker">{d.category || "Document"}</span>
                  <h3>{d.title}</h3>
                  <p>{d.description}</p>
                </div>
                {d.file_url ? (
                  <a href={d.file_url} target="_blank" rel="noreferrer" className="button button-dark" data-testid={`document-download-${i}`}>
                    Download <Download size={15} />
                  </a>
                ) : (
                  <span className="pill" data-testid={`document-pending-${i}`}>File coming soon</span>
                )}
              </div>
            </Reveal>
          )) : (
            <div className="empty-state" data-testid="documents-empty-state">No downloads published yet.</div>
          )}
        </div>
      </main>
    </Shell>
  );
}
